import InputType from "@/services/Input/InputType.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Search: {
    Label: "Cari Nama, atau Alamat",
    Type: InputType.Text,
    MaxLength: 100
  }
}